import React, {useState, useEffect} from "react";
import Section from "./layouts/Section";
import {WebLink, SiteWide} from "./customComponents";
import { useSelector, useDispatch } from 'react-redux';

import {authActions} from '../redux/actions';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect} from '../redux/selectors/index';
import Helper1, {notify, money, customNormalModalStyles} from '../utility/Helper1';
import {homepage} from '../utility/APIRequests';

import Countdown from 'react-countdown';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {staticCountries} from '../utility/countries';
import {Images} from "./customComponents";
import Slider from "react-slick";
import { RiPhoneLockFill, RiBankFill,RiStackshareLine, RiWallet3Fill, RiArrowGoBackLine, RiEarthLine, RiLockUnlockLine, RiAccountBoxFill, RiSecurePaymentLine, RiListOrdered, RiLockPasswordFill, RiLoginBoxFill, RiMouseLine } from "react-icons/ri";
import {mainStyle, mainColor, header, footer, otherColors} from '../utility/styles';
import { Eye, EyeOff, Shield, CheckCircle, Key, Smartphone, Mail } from 'lucide-react';


function ChangePin({history}){

    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const finance = useSelector(homeScreenStatSelect);

    const [withdrawalPin, setWithdrawalPin]   = useState('');
    const [emailOTP, setEmailOTP]   = useState('');
    
    // UI states
    const [showPin, setShowPin] = useState(false);
    const [showOTP, setShowOTP] = useState(false);
    
    const [loading, setloading]   = useState();
    const [loadingText, setLoadingText]   = useState('Loading...');

    const dispatch = useDispatch();

    


    const doWithdrawalPinChange = (e) => {

        e.preventDefault();
        setloading(true)
        setLoadingText('Changing Withdrawal PIN...')

        dispatch(authActions.onLogin(`account/withdrawal-pin/change`, {emailOTP, withdrawalPin}, response => {
            notify(response.msg, response.code)
            setloading(false);
            if(response.code == 1){  setWithdrawalPin(''); }
        }),
        );

    }
  const getNewEmailOTP = () => {

        dispatch(authActions.onLogin(`account/send-email-otp/withdrawal-pin`, {}, response => {

        }),
        );

    }


    useEffect(() => {
        getNewEmailOTP();
    }, [])

    return (
        <SiteWide title={`Change PIN`}>
            <Section loading={loading} overlayText={loadingText} title={'Change PIN'}>
                <div className="min-h-screen p-4">
                    <div className="max-w-4xl mx-auto pt-8">
                        {/* Modern Header */}
                        <div className="text-center mb-12">
                            <h1 className="text-5xl font-bold text-white mb-4 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                                Change PIN
                            </h1>
                            <p className="text-xl text-blue-200">
                                Update your withdrawal PIN for enhanced security
                            </p>
                        </div>

                        <div className="flex flex-col gap-8">
                            {/* Enhanced PIN Change Card */}
                            <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-8 shadow-2xl">
                                <div className="relative overflow-hidden">
                                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500"></div>
                                    <div className="flex items-center mb-8">
                                        <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center mr-6 shadow-lg">
                                            <Smartphone className="text-white" size={28} />
                                        </div>
                                        <div>
                                            <h2 className="text-3xl font-bold text-white mb-2">PIN Security</h2>
                                            <p className="text-gray-300">Keep your withdrawal PIN secure and up to date</p>
                                        </div>
                                    </div>
                                    
                                    <form onSubmit={doWithdrawalPinChange} className="space-y-6">
                                        <div>
                                            <label className="block text-white font-medium mb-3 text-lg">New PIN</label>
                                            <div className="relative">
                                                <input
                                                    type={showPin ? 'text' : 'password'}
                                                    value={withdrawalPin}
                                                    onChange={(e) => setWithdrawalPin(e.target.value)}
                                                    maxLength={4}
                                                    className="w-full bg-white/10 border-2 border-white/20 rounded-2xl px-6 py-4 pr-16 text-white text-lg placeholder-gray-300 focus:outline-none focus:border-blue-400 transition-all duration-300"
                                                    placeholder="Enter new 4-digit PIN"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => setShowPin(!showPin)}
                                                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-300 hover:text-white transition-colors"
                                                >
                                                    {showPin ? <EyeOff size={20} /> : <Eye size={20} />}
                                                </button>
                                            </div>
                                            <p className="text-gray-400 text-sm mt-2">PIN must be exactly 4 digits</p>
                                        </div>
                                        
                                        <div>
                                            <label className="block text-white font-medium mb-3 text-lg">Email OTP</label>
                                            <div className="relative">
                                                <input
                                                    type={showOTP ? 'text' : 'password'}
                                                    value={emailOTP}
                                                    onChange={(e) => setEmailOTP(e.target.value)}
                                                    className="w-full bg-white/10 border-2 border-white/20 rounded-2xl px-6 py-4 pr-16 text-white text-lg placeholder-gray-300 focus:outline-none focus:border-yellow-400 transition-all duration-300"
                                                    placeholder="Enter OTP from email"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => setShowOTP(!showOTP)}
                                                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-300 hover:text-white transition-colors"
                                                >
                                                    {showOTP ? <EyeOff size={20} /> : <Eye size={20} />}
                                                </button>
                                            </div>
                                            <div className="flex justify-between items-center mt-2">
                                                <p className="text-gray-400 text-sm">Enter the OTP sent to your email</p>
                                                <Countdown
                                                    zeroPadTime={2}
                                                    key={new Date(userData?.withdrawalPinResetTime ?? 0)}
                                                    date={new Date(userData?.withdrawalPinResetTime ?? 0)}
                                                    renderer={({ hours, minutes, seconds, completed }) => {
                                                        if (completed) {
                                                            return (
                                                                <button
                                                                    type="button"
                                                                    onClick={getNewEmailOTP}
                                                                    className="text-blue-400 hover:text-blue-300 text-sm font-medium transition-colors"
                                                                >
                                                                    Request OTP
                                                                </button>
                                                            );
                                                        } else {
                                                            return (
                                                                <span className="text-gray-400 text-sm">
                                                                    {minutes}:{seconds} seconds
                                                                </span>
                                                            );
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        
                                        <div className="flex gap-4 pt-6">
                                            <button
                                                type="submit"
                                                disabled={loading}
                                                className={`flex-1 py-4 px-6 rounded-2xl font-semibold text-white transition-all duration-300 text-lg ${
                                                    loading 
                                                        ? 'bg-gray-500 cursor-not-allowed' 
                                                        : 'bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 hover:scale-105 shadow-lg hover:shadow-blue-500/25'
                                                }`}
                                            >
                                                {loading ? (
                                                    <div className="flex items-center justify-center">
                                                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                                                        Updating...
                                                    </div>
                                                ) : (
                                                    'Update PIN'
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {/* Security Tips Card */}
                            <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-8 shadow-2xl">
                                <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
                                    <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-blue-600 rounded-2xl flex items-center justify-center mr-4 shadow-lg">
                                        <Shield className="text-white" size={24} />
                                    </div>
                                    PIN Security Tips
                                </h3>
                                
                                <div className="grid md:grid-cols-2 gap-6">
                                    <div className="flex items-start gap-4">
                                        <CheckCircle className="text-green-400 mt-1" size={20} />
                                        <div>
                                            <h4 className="text-white font-semibold mb-1">Memorable but Secure</h4>
                                            <p className="text-gray-300 text-sm">Choose a PIN that's easy to remember but hard to guess</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-4">
                                        <CheckCircle className="text-green-400 mt-1" size={20} />
                                        <div>
                                            <h4 className="text-white font-semibold mb-1">Avoid Common Patterns</h4>
                                            <p className="text-gray-300 text-sm">Don't use sequential numbers like 1234 or repeated digits</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-4">
                                        <CheckCircle className="text-green-400 mt-1" size={20} />
                                        <div>
                                            <h4 className="text-white font-semibold mb-1">Keep it Private</h4>
                                            <p className="text-gray-300 text-sm">Never share your PIN with anyone or write it down</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-4">
                                        <CheckCircle className="text-green-400 mt-1" size={20} />
                                        <div>
                                            <h4 className="text-white font-semibold mb-1">Regular Updates</h4>
                                            <p className="text-gray-300 text-sm">Change your PIN periodically for better security</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>
        </SiteWide>
    );

}

export default ChangePin;